import React from 'react'
import Lottie from "react-lottie-player/dist/LottiePlayerLight";
import LoadingSpinnerJson from "../../assets/loading-spinner/LoadingSpinner.json"

const LoadingSpinner = () => {
    return (
        <div className='LoadingSpinner  flex justify-content-center align-items-center' style={{ height: "100vh", width: "100vw" }}>
            <Lottie play loop={false} animationData={LoadingSpinnerJson} style={{ width: '15rem', height: "15rem" }} />
        </div>
    )
}

export default LoadingSpinner